import { PackageDiscount } from 'components/enrollForm/enrollFormTypes'

export type PackageDiscountAllocation = {
    discountPerPackage: number
    discountedCartUnits: number
}

/**
 * Resolve which cart units get the tier discount (mirrors core row allocation).
 * Tier from owned + cartQty; only min(cart, cap - owned) cart units are discounted.
 */
export const getPackageDiscountAllocation = (
    discount: PackageDiscount | undefined,
    newQuantity: number,
    existingQuantity = 0
): PackageDiscountAllocation => {
    const empty = { discountPerPackage: 0, discountedCartUnits: 0 }
    const tiers = discount?.tiers
    if (!tiers?.length || newQuantity <= 0) {
        return empty
    }

    const totalQuantity = existingQuantity + newQuantity
    const applicableTier = tiers
        .filter((tier) => tier.min_quantity <= totalQuantity)
        .sort((a, b) => b.min_quantity - a.min_quantity)

    const selectedTier = applicableTier[0]
    if (!selectedTier) {
        return empty
    }

    const maxCap = discount?.max_discounted_quantity
    const cap = maxCap ?? Number.POSITIVE_INFINITY
    const remainingDiscountableSlots = Math.max(0, cap - existingQuantity)
    const discountedCartUnits = Math.min(
        newQuantity,
        remainingDiscountableSlots
    )

    return {
        discountPerPackage: selectedTier.discount_per_package,
        discountedCartUnits
    }
}

/**
 * Total CFA saved on cart lines for one package_id.
 */
export const getPackageDiscountAmount = (
    discount: PackageDiscount | undefined,
    newQuantity: number,
    existingQuantity = 0
): number => {
    const { discountPerPackage, discountedCartUnits } =
        getPackageDiscountAllocation(discount, newQuantity, existingQuantity)
    return discountedCartUnits * discountPerPackage
}
